import React from 'react'

import CustomerSelectField from './CustomerSelectField'

type UseChangeResponseCustomerProps = {
  fetchData: () => Promise<void>
  isAnonymous: boolean
}

function useResponseChangeCustomer({
  fetchData,
  isAnonymous,
}: UseChangeResponseCustomerProps) {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  return [
    <CustomerSelectField
      fetchData={fetchData}
      isAnonymous={isAnonymous}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    />,
    {
      title: `Assign to ${isAnonymous ? 'a' : 'another'} patient`,
      onClick: () => {
        setIsModalOpen(true)
      },
    },
  ]
}

export default useResponseChangeCustomer
